<div class="container section-gap">
  <div class="row">
    <div class="col-lg-6">
      <kla-title [lineConfig]="lineConfig" [config]="config.title" [showFooter]="false"></kla-title>
    </div>
    <div class="col-lg-6">
      <div class="bubble-chart-container" #panel>
        <kla-bubble-chart *ngIf="showChart" [config]="chartConfig" [width]="chartConfig.width"></kla-bubble-chart>
      </div>
      <div class="footer-paragraph" *ngIf="config.title.footer">
        <app-dynamic-content
          [contentId]="'indicator-bubble-footer'"
          [htmlContent]="config.title.footer">
        </app-dynamic-content>
      </div>
    </div>
  </div>
</div>
